import {Box, Divider} from '@mui/material';

import {MatchFilterOptions, MatchFilters} from '../MatchFilters/MatchFilters';
import {MatchListTable} from '../MatchListTable/MatchListTable';

import {LoadingContainer} from '../../../../../components/Loading/LoadingContainer';
import {orangeColors} from '../../../../../layouts/theme/designSystem';
import {MatchData} from '../../../../../types/shared-recruiting-types';
import {Option} from '../../../../../types/shared-types';

interface Props {
  loadingInitialData: boolean;
  matches: MatchData[] | null;
  filterBy: (filter: MatchFilterOptions) => void;
  jobOptions: Option[];
  statusOptions: Option[];
  initialJobs: Option[];
  initialStatuses: Option[];
  pagination?: {
    page: number;
    perPage: number;
    totalPages: number;
    totalCount: number;
    nextPage: number | null;
    previousPage: number | null;
  };
  hasNext?: boolean;
  getNext?: () => void;
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
}

export const MatchesTableView = ({
  loadingInitialData,
  matches,
  filterBy,
  jobOptions,
  statusOptions,
  initialJobs,
  initialStatuses,
  pagination,
  hasNext,
  getNext,
  searchTerm,
  onSearchTermChange,
}: Props) => {
  return (
    <Box
      data-tour='matches.table'
      sx={{
        bgcolor: 'white',
        border: `1px solid ${orangeColors[3]}`,
        borderRadius: '16px',
        px: {xs: 2, sm: 3},
        pt: 3,
        pb: 4,
        overflow: 'hidden',
      }}
    >
      {loadingInitialData || matches === null ? (
        <LoadingContainer minHeight='50vh' sx={{minHeight: {xs: '30vh', sm: '40vh', md: '50vh'}}} />
      ) : (
        <>
          <Box data-tour='matches.tableFilters'>
            <MatchFilters
              filterBy={filterBy}
              jobOptions={jobOptions}
              statusOptions={statusOptions}
              initialJobs={initialJobs}
              initialStatuses={initialStatuses}
              searchTerm={searchTerm}
              onSearchTermChange={onSearchTermChange}
            />
          </Box>
          <Divider sx={{my: 2.5, borderColor: orangeColors[3]}} />
          <Box data-tour='matches.tableList'>
            <MatchListTable matches={matches} pagination={pagination} hasNext={hasNext} getNext={getNext} />
          </Box>
        </>
      )}
    </Box>
  );
};
